<template>
  <div id="index_contact" :style="bg">
    <u-animate-container class="container">
      <u-animate class="txt" name="bounceInleft" delay="0s" duration="1s" :iteration="1" :offset="0" animateClass="animated" :begin="false" >
        {{$t('index.contact.desc')}}
      </u-animate>
      <div class="btn_contact" @click="goContact">
        <img src="@/assets/images/icon_email.png" >
        <span>{{$t('index.contact.btn')}}</span>
      </div>
    </u-animate-container>
  </div>
</template>

<script>
import {UAnimateContainer, UAnimate} from 'vue-wow'
const contactbg = require('@/assets/images/bg_index_contact.jpg')
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  props: {
    locale: {
      type: String,
      default: 'cn'
    }
  },
  methods: {
    goContact () {
      console.log(11)
      this.$router.push({
        name: 'Contact'
      })
    }
  },
  data () {
    return {
      bg: {
        'background': 'url(' + contactbg + ') no-repeat center center',
        'background-size': '100% 100%'
      }
    }
  }
}
</script>

<style scoped lang="scss">
  #index_contact{
    width:100%;
    background-size:100% 100%;
    height:120px;
    position:relative;
    .container{
      width:1140px;
      height:120px;
      line-height: 120px;
      margin:0 auto;
    }
    .txt{
      font-size:28px;
      line-height: 120px;
      color:#fff;
      float:Left;
      position: relative;
    }
    .btn_contact{
      color:#fff;
      height: auto;
      padding:15px 35px;
      border-radius: 30px;
      background:none;
      text-align: center;
      border:2px solid #fff;
      float:right;
      cursor: pointer;
      margin-top:33px;
      img{
        width:20px;
        height:auto;
        margin-right:12px;
        float:left;
        position: relative;
        top: 3px;
      }
      span{
        float:left;
        height:20px;
        line-height: initial;
        font-size:0.18rem;
      }
    }
    img{
      &.bg{
        width:100%;
        position: absolute;
        height:100%;
        z-index: 0;
        height:auto;
      }
    }
  }
  @media screen and (max-width: 750px) {
    #index_contact{
      height:auto;
      overflow: hidden;
      .container{
        width:100%;
        box-sizing: border-box;
        height:auto;
        line-height: 1.5;
        padding:30px;
        .txt{
          font-size:1em;
          width:100%;
          text-align: center;
          float:none;
          line-height: 1.5;
        }
      }
      .btn_contact{
        float:none;
        margin-left:auto;
        margin-right:auto;
        width:60%;
        height:62px;
        display: flex;
        align-items: center;
        justify-items: center;
        box-sizing: border-box;
        justify-content: center;
        img{
          display: flex;
          float:none;
          top:2px;
        }
        span{
          display: flex;
          float:none;
          font-size:1rem;
          height:auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexContact.vue